var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PhotoPost ty-flex ty-flex-wrap"},[_c('div',{class:['side-width', _vm.order === 'right' ? 'right' : 'order-2']},[_c('h3',{class:[
        'post-head',
        'fs-22',
        'fw-500',
        'mb-0',
        _vm.order === 'right' ? 'mr-auto' : '' ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{class:['fw-300', 'par', 'mt-3', _vm.order === 'right' ? 'mr-auto' : '']},[_vm._v(" "+_vm._s(_vm.explain)+" ")])]),_c('div',{class:['side-width', _vm.order === 'left' ? 'right order-1' : '']},[_c('div',{staticClass:"img-part"},[_c('img',{attrs:{"src":_vm.image_source,"alt":"my-post"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }